/* eslint-disable max-lines */
import pluralize from 'pluralize';
import React from 'react';
import { getIdentifierCustomers } from 'selectors/identifier';
import { useSelector } from 'store';

const CategorizerWorkspaceTable: React.FC = () => {
  const customers = useSelector(getIdentifierCustomers);
  const allCustomers = useSelector(getIdentifierCustomers);

  const renderWorkspaces = (): JSX.Element[] =>
    customers.map((c) => (
      <tr
        key={c.uuid}
        className="table-row border-t border-litlingo-gray-1 align-middle hover:bg-litlingo-gray-0 text-body"
      >
        <td className="table-wrapper__new-td p-0 pl-4">
          <div className="table-wrapper__new-cell-content h-10 flex items-center text-body truncate">
            {c.name}
          </div>
        </td>
        <td className="table-wrapper__new-cell-content h-10 p-0 overflow-visible">
          <div className="table-wrapper__new-cell-content h-10 flex items-center text-body text-left truncate">
            On
          </div>
        </td>
      </tr>
    ));

  const renderWorkspaceTable = (): JSX.Element => (
    <div className="max-h-full table-wrapper__new no-scrollbar overflow-auto">
      <table className="table-wrapper__table table-wrapper_table--fixed">
        <thead className="sticky top-0 z-10">
          <tr className="table-wrapper__header-tr h-10">
            <th className="table-wrapper__new-th p-0 pl-6">Name</th>

            <th className="table-wrapper__new-th table-wrapper__th--w-35 p-0">State</th>
          </tr>
        </thead>
        <tbody className="table-wrapper__tbody">{renderWorkspaces()}</tbody>
      </table>
    </div>
  );

  return (
    <div className="h-full w-124 mt-4 flex flex-col gap-8 overflow-hidden">
      <div className="border-b border-litlingo-gray-2" />
      <div className="h-full flex flex-col gap-2 overflow-hidden">
        <div className="flex flex-row justify-between">
          <p className="font-bold">Scoped Workspaces</p>
          <p className="">
            {customers.length} of {allCustomers.length} {pluralize('Space', allCustomers.length)}
          </p>
        </div>
        {customers.length > 0 ? (
          renderWorkspaceTable()
        ) : (
          <div>
            <p>
              {allCustomers.length > 0
                ? 'Request permissions to relevant workspaces to see them here.'
                : 'No workspaces found. To add one, ensure that this LLM Categorizer is attached to a model and has a workspace attached.'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CategorizerWorkspaceTable;
